module.exports = __webpack_public_path__ + "static/media/snooze.618b25e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/Rules/layouts/OptInModal/images/snooze.png
// module id = N0ey
// module chunks = 89